module.exports = __webpack_public_path__ + "2943954ffab2b596f525256089d9048f.svg";